import { Button } from '@/components/ui/button'
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

export interface DeleteTableColumnProps {
  onClose: () => void
  fieldName: string
  onDelete: () => void
}

export const DeleteTableColumnModal = ({
  onClose,
  fieldName,
  onDelete,
}: DeleteTableColumnProps) => {
  return (
    <DialogContent className="container mx-auto flex flex-col max-w-lg bg-modal-gradient rounded-lg border-modal-border-color">
      <DialogHeader>
        <DialogTitle>Delete {fieldName} Field?</DialogTitle>
      </DialogHeader>
      <div className="py-4">
        Deleting this field will affect any site elements it's connected to.
        Changes will go live right away.
      </div>
      <div className="flex gap-3 items-center justify-end">
        <Button
          type="button"
          size="custom"
          variant="ghost"
          onClick={onClose}
          className="rounded-lg px-8 py-2 hover:decoration-transparent"
        >
          Cancel
        </Button>
        <Button
          type="button"
          size="custom"
          variant="destructive"
          className="rounded-lg px-8 py-2 hover:bg-[#ff5537] hover:text-white bg-transparent border-1 border-[#ff5537] text-[#ff5537]"
          // TODO: add loading state
          // disabled={loading.crud.CREATE}
          onClick={onDelete}
        >
          Delete
        </Button>
      </div>
    </DialogContent>
  )
}
